import { MenuItem, Select, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import Button from "../../../../components/Common/Button";
import { selectUid } from "../../../../slices/auth";
import { updateStudentBgItem } from "../../../../api/common";
import { updateUser } from "../../../../api/user";
import "./style.scss";
import { languages as languagesDataset } from "../../../../db/datasets/languages";
import { analyticsEvents, languageLevels } from "../../../../db/models/const";

interface Props {
	handleGoNext: Function;
}

const StudentOnboardingLanguage = ({ handleGoNext }) => {
	const [loading, setLoading] = useState(false);
	const uid = useSelector(selectUid);
	const { t } = useTranslation();

	const { handleSubmit, control, errors } = useForm({
		defaultValues: {
			label1: null,
			levelId1: null,
			label2: null,
			levelId2: null,
		},
	});

	const onSave = async (form: any) => {
		const l1 = {
			labelId: form.label1.id,
			levelId: form.levelId1,
		};

		const l2 = form.label2
			? {
					labelId: form.label2.id,
					levelId: form.levelId2,
			  }
			: null;

		const l3 = form.label3
			? {
					labelId: form.label3.id,
					levelId: form.levelId3,
			  }
			: null;

		setLoading(true);

		await updateStudentBgItem(uid, "LANG", l1, true);
		if (l2) await updateStudentBgItem(uid, "LANG", l2, true);
		if (l3) await updateStudentBgItem(uid, "LANG", l3, true);

		setLoading(false);
		handleGoNext();
	};

	return (
		<div className="studentOnboardingLanguage dark-bg">
			<div className="container">
				<div className="card p-4">
					<h2 className="fs-2 fw-bolder">{t("student_onboarding_language_title")}</h2>
					<p className="mb-4 fs-4">{t("student_onboarding_language_subtitle")}</p>
					<form onSubmit={handleSubmit(onSave)}>
						{[...Array(3)].map((_, i) => (
							<div className="mb-4 p-2 group">
								<p className="fw-bold text-center mb-4">{`${t("student_onboarding_language_group")} ${i + 1}`}</p>
								<div className="element">
									<div className="label">{t("student_lang_label")}</div>
									<Controller
										render={({ onChange, ...props }) => (
											<Autocomplete
												{...props}
												options={languagesDataset}
												getOptionLabel={(option) => option.label}
												renderInput={(params) => <TextField {...params} />}
												onChange={(e, x) => {
													onChange(x);
												}}
											/>
										)}
										name={`label${i + 1}` as any}
										rules={{ required: i === 0 ? true : false }}
										control={control}
									/>
									{errors[`label${i + 1}`] && <p>{t("student_lang_error")}</p>}
								</div>
								<div className="element">
									<div className="label">{t("student_lang_level_label")}</div>
									<Controller
										render={({ onChange, ...props }) => (
											<Select fullWidth {...props} onChange={(e) => onChange(e.target.value)}>
												{languageLevels.map((x) => (
													<MenuItem key={x.id} value={x.id}>
														{t(x.label)}
													</MenuItem>
												))}
											</Select>
										)}
										name={`levelId${i + 1}` as any}
										rules={{ required: i === 0 ? true : false }}
										control={control}
									/>
									{errors[`levelId${i + 1}`] && <p>{t("student_lang_level_error")}</p>}
								</div>
							</div>
						))}
						{errors["label1"] && <p className="text-danger">{t("student_onboarding_language_error")}</p>}
						{!loading && (
							<Button type="submit" filled loading={loading} backgroundColor="#3392E8" borderColor="#3392E8">
								{t("student_onboarding_nextBtn")}
							</Button>
						)}
						{loading && (
							<div className="loader">
								<ClipLoader size={20} color={"#7400b8"} loading={true} />
							</div>
						)}
					</form>
				</div>
			</div>
		</div>
	);
};

export default StudentOnboardingLanguage;
